import { Component, Fragment, useContext, useEffect, useState } from "react";
import Header from "../component/layout/header";
import Footer from "../component/layout/footer";
import PageHeader from "../component/layout/pageheader";
import { ShopContext } from "../context/ShopContext";
import axios from 'axios';

const title = "Order History";



const Orders = () => {

  const {backendUrl, token, currency} = useContext(ShopContext)
  const [orderData, setorderData] = useState([])

  const statusClassMap = {
  "Order Placed": "orderplaced",
  "Packing": "packing",
  "Shipped": "shipped",
  "Out for delivery": "ofd",
  "Delivered": "delivered",
  "Cancelled": "cancelled",
  };

  const loadOrderData = async () => {
    try {
      if (!token) {
        return null
      }

      const response = await axios.post(backendUrl + '/api/order/userorders',{}, {headers: {token}})
      if (response.data.success) {
        let allOrdersItem = []
        response.data.orders.map((order) => {
          order.items.map((item)=>{
            item['status'] = order.status
            item['payment'] = order.payment
            item['paymentMethod'] = order.paymentMethod
            item['date'] = order.date
            allOrdersItem.push(item)
          })
        })
        setorderData(allOrdersItem.reverse())
      }
    

    } catch (error) {
      
    }
  }

  useEffect(() => {
    loadOrderData()
  }, [token])
  
    return (
      <Fragment>
        <Header />
        <PageHeader title={"ORDERS"} curPage={"ORDERS"} />

        <section className="orders-fx-section padding-top padding-bottom">
          <div className="container">
            <div className="text-right">
              
              <h2>{title}</h2>
            </div>

            <div className="orders-fx-wrapper">
              {orderData.map((order, index) => (
                <div className="order-fx-card" key={index}>
                  {/* Glow layer */}
                  <span className="order-fx-glow" />

                  {/* Product image */}
                  <div className="order-fx-image">
                    <img src={order.image} alt={order.title} />
                  </div>

                  {/* Product info */}
                  <div className="order-fx-info">
                    <h4>{order.title}</h4>

                    <div className="order-fx-meta">
                      <span>Price: <strong>{currency}{order.price}</strong></span>
                      <span>Qty: <strong>{order.quantity}</strong></span>
                      <span>Size: <strong>{order.size}</strong></span>
                    </div>

                    <div className="order-fx-sub">
                      <span>Order ID: {order.orderId}</span>
                      <span>Placed: {new Date(order.date).toDateString()}</span>                      
                    </div>

                    <div className="order-fx-sub">
                      <span>Payment: {order.paymentMethod}</span>
                    </div>
                  </div>

                  {/* Status + action */}
                  <div className="order-fx-action">
                    <span
                      className={`order-fx-status ${
                        statusClassMap[order.status] || ""
                      }`}
                    >
                      {order.status}
                    </span>

                    <button onClick={loadOrderData} className="default-button">
                      <span>Track Order</span>
                    </button>
                  </div>
                </div>
              ))}

              {orderData.length === 0 && (
                <p className="text-center">No orders found.</p>
              )}
            </div>
          </div>
        </section>

        <Footer />
      </Fragment>
    );
  
}

export default Orders;
